import { createContext } from '@lit/context';

export const readOnlyContext = createContext<boolean>(Symbol('readOnly'));
